import { sortBy } from "../../../common/CCUtils"
import { StudentResults } from "../../../react/students/StudentResults"
import { StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { PlaygroundPromise } from "./PlaygroundType"

export class PlaygroundStore {
    private static innerInstance: PlaygroundStore

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    savePromise = (playgroundPromise: PlaygroundPromise) => {
        const update: Partial<StudentResults> = {
            playgroundPromise
        }
        StudentResultsStore.instance.update(update)
    }

    findPromises = () => {
        return StudentResultsStore.instance.studentResultsArray
                                            .map(results => results.playgroundPromise)
                                            .filter(promise => promise != null)
                                            .sort(sortBy((promise: PlaygroundPromise) => promise.date.toDate()))
    }

}
